const hasRedirectTrips = (trips) => {
  if (!trips) return false;

  const redirectTrips = trips.filter((trip) => trip.get('redirectTo') !== null);

  return redirectTrips.size > 0;
};

export default hasRedirectTrips;
